import { Typography } from "@mui/material";
import { TEXT } from "../utils/tokens";

/**
 * 空であること自体が情報になる場所の表示。面を作らず、14px の text.secondary の1行で済ませる（方針書 2-7）。
 */
export const EmptyState: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography sx={{ ...TEXT.body, color: "text.secondary" }}>
    {children}
  </Typography>
);
